import React from 'react';
import { Globe, ShieldAlert } from 'lucide-react';
import { Pill } from '../ui';
import { SupplierView } from './discoveryModel';
import { TRUST_BAR } from './discoveryInsights';

/**
 * Warnings the backend decided at shortlisting and saved on the candidate — this only
 * reads them, it never re-derives them.
 */
interface SupplierFlagsProps {
  supplier: Pick<SupplierView, 'outsideSourcingLocation' | 'belowTrustBar' | 'trustScore'>;
  className?: string;
}

export const SupplierFlags: React.FC<SupplierFlagsProps> = ({ supplier, className = '' }) => {
  const belowBar = supplier.belowTrustBar === true && supplier.trustScore != null;
  if (!supplier.outsideSourcingLocation && !belowBar) return null;
  return (
    <span className={`flex flex-wrap items-center gap-s1 ${className}`}>
      {supplier.outsideSourcingLocation && (
        <Pill
          status="warn"
          className="shrink-0 whitespace-nowrap font-semibold"
          title="Outside the sourcing location you asked for — check shipping and lead time"
        >
          <Globe className="h-3 w-3" aria-hidden /> Outside your location
        </Pill>
      )}
      {belowBar && (
        <Pill
          status="warn"
          className="shrink-0 whitespace-nowrap font-semibold"
          title={`Trust score ${supplier.trustScore} is under your trust bar of ${TRUST_BAR}. A low score often means little public evidence, not a bad supplier — check the trust details before you award.`}
        >
          <ShieldAlert className="h-3 w-3" aria-hidden /> Below your trust bar · {supplier.trustScore}
        </Pill>
      )}
    </span>
  );
};

export default SupplierFlags;
